import { CgMenuRound, CgCloseO } from "react-icons/cg";

import { AnimatePresence, motion } from "framer-motion";
import { PiChatTeardropDotsBold, PiChatTeardropTextBold } from "react-icons/pi";
import { useEffect, useState } from "react";

export default function ChatHeader({
  containerRef,
  handlesubmenu,
  setHandelsubmenu,
  handelnewchats,
  handelendchats,
  handleDownload,
}) {
  const [showBottomRadius, setShowBottomRadius] = useState(false);

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
    setShowBottomRadius(!isAtBottom);
  };

  useEffect(() => {
    const ref = containerRef.current;
    ref.addEventListener("scroll", handleScroll);
    handleScroll(); // initial check
    return () => ref.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      animate={{
        boxShadow: showBottomRadius ? "0px 2px 1px rgba(0, 0, 0, 0.1)" : "none",
      }}
      transition={{ duration: 0.3 }}
      id="chatnav"
      className={`sticky top-0 w-full bg-white z-10`}>
      <div className="w-full flex justify-between h-fit px-10 py-2 font-bold tracking-wide relative text-lg">
        <div>Chat Now</div>
        <AnimatePresence>
          <button onClick={() => setHandelsubmenu((prev) => !prev)}>
            {handlesubmenu ? (
              <CgCloseO className="w-6 h-6" />
            ) : (
              <CgMenuRound className="w-6 h-6" />
            )}
            {handlesubmenu && (
              <motion.div
                initial={{ scale: 0.6, opacity: 0.6, y: -50 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.6, opacity: 0.6, y: -50 }}
                role="menu"
                aria-label="Chat options"
                className="absolute top-10 right-2 flex flex-col whitespace-nowrap bg-white text-black rounded shadow-md shadow-gray-400 gap-2">
                <button
                  role="menuitem"
                  onClick={handelnewchats}
                  className="p-2 px-5 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 flex gap-2 rounded"
                  tabIndex={0}>
                  <PiChatTeardropDotsBold
                    className="w-6 h-6"
                    aria-hidden="true"
                  />
                  Start a new chat
                </button>
                {/* <button
                  role="menuitem"
                  onClick={handelendchats}
                  className="p-2 px-5 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 flex gap-2 rounded"
                  tabIndex={0}>
                  <PiChatTeardropSlashBold
                    className="w-6 h-6"
                    aria-hidden="true"
                  />
                  End chat
                </button> */}
                <button
                  role="menuitem"
                  onClick={handleDownload}
                  className="p-2 px-5 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 flex gap-2 rounded"
                  tabIndex={0}>
                  <PiChatTeardropTextBold
                    className="w-6 h-6"
                    aria-hidden="true"
                  />
                  Download conversation
                </button>
              </motion.div>
            )}
          </button>
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
